import React, { FC } from 'react';
import NextImage, { ImageProps } from 'next/image';

type Props = Partial<ImageProps>;

const Image: FC<Props> = (props) => {
  const imageProps = { ...props } as ImageProps;
  const { alt, ...rest } = imageProps;
  return <NextImage alt={alt || ''} {...rest} />;
};

export default Image;
